var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-col',{attrs:{"lg":"8","sm":"6","xs":"12"}},[_c('p',{class:_vm.index % 2 == 1 ? 'cyberpunk-reverse-clip' : ''},[_vm._v(" "+_vm._s(_vm.content)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }